import { gql } from '@/Types/gql';

export const GET_LOG_INFO = gql(`query GetLogInfo($id: ID!) {
  getLogInfo(_id: $id) {
    status
  }
}`);

export const GET_ASSESSMENT = gql(`
  query GetAllAssessment($filter: JSON) {
  getAllAssessment(filter: $filter) {
    _id
    assessment
    createdAt
    createdById
    sessionId
    traineeId
    trainerId
  }
}
`);
